/* eslint-disable react/jsx-key */
import * as Yup from 'yup';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';
import TextMaxLine from '../../../components/TextMaxLine';
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import { Section } from 'src/@types/Course';

// ----------------------------------------------------------------------

type Props = {
  isEdit: boolean;
  currentSection?: Section;
  onSubmit(data: Section): void;
};

export default function NewSectionForm({
  isEdit,
  currentSection,
  onSubmit,
}: Props) {

  const NewSectionSchema = Yup.object().shape({
    title: Yup.string().min(3).required('Section title is required'),
    description: Yup.string().min(3).required('description is Required'),
    order: Yup.number().required('Section Order is Required'),
  });

  const defaultValues: Section = useMemo(
    () => ({
      title: currentSection?.title || '',
      title_ar: currentSection?.title_ar || '',
      description: currentSection?.description || '',
      description_ar: currentSection?.description_ar || '',
      items: currentSection?.items || [],
      order: currentSection?.order || 0,
    }),
    [currentSection]
  );

  const methods = useForm<Section>({
    resolver: yupResolver(NewSectionSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;


  useEffect(() => {
    if (isEdit && currentSection) {
      reset(defaultValues);
    }
    if (!isEdit) {
      reset(defaultValues);
    }
  }, [isEdit, currentSection]);

  return (
    <>
      <Stack height={'100%'} sx={{ overflow: 'auto' }}>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <TextMaxLine marginBottom={'20px'} marginTop={'20px'} fontSize={'22px'}>
            {isEdit ? ' Edit Section' : ' Create Section'}
          </TextMaxLine>
          <Stack direction={'column'} justifyContent={'space-between'} height={'91%'}>
            <Stack direction={'column'} spacing={5} overflow={'auto'}>
              <Box
                sx={{
                  display: 'flex',
                  flex: 9,
                  columnGap: 2,
                  paddingTop: '10px',
                  rowGap: 5,
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                }}
              >
                <RHFTextField sx={{ width: '100%' }} name="title" label="English title" />
                <RHFTextField sx={{ width: '100%' }} name="title_ar" label="Arabic title" />
              </Box>
              <RHFTextField
                multiline
                minRows={2}
                name="description"
                maxRows={3}
                label="English Description"
              />
              <RHFTextField
                multiline
                minRows={2}
                name="description_ar"
                maxRows={3}
                label="Arabic Description"
              />
            </Stack>
            <Stack alignItems="flex-end" sx={{ mt: 3 }}>
              <LoadingButton
                style={{ width: '200px', height: '50px' }}
                type="submit"
                variant="contained"
                loading={isSubmitting}
              >
                {!isEdit ? 'Create Section' : 'Save Changes'}
              </LoadingButton>
            </Stack>
          </Stack>
        </FormProvider>
      </Stack>
    </>
  );
}
